export enum NotificationStatus {
  SKETCH = 'SKETCH',
  SENT = 'SENT',
}

export enum NotificationDirectType {
  APP_AREA = 'APP_AREA',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
}

export const translateNotificationStatus = (status: NotificationStatus | string): string => {
  switch (status) {
    case NotificationStatus.SKETCH:
      return 'Rascunho';
    case NotificationStatus.SENT:
      return 'Enviado';
    default:
      return status;
  }
};

/**
 * Status de disparo da notificação agendada. Espelha localmente o enum
 * `NotificationDispatchStatus` de `types-sdk-node/src/enums.ts` (Fase 1 do
 * plano de agendamento) — este repo não importa diretamente do SDK, então o
 * mapeamento é mantido em sincronia manualmente.
 */
export enum NotificationDispatchStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SENT = 'SENT',
  FAILED = 'FAILED',
}

export type Notification = {
  uuid: string;
  title: string;
  business_unit_uuid: string;
  content: string;
  scheduled_at: string;
  status?: NotificationDispatchStatus;
  created_at: string;
  updated_at: string;
};
